<template>
    <v-dialog max-width="500" v-model="dialog" scrollable>
        <v-card class="pa-1">
                <v-alert
                        v-model="alert"
                        dismissible
                        icon="fas fa-exclamation-circle"
                        type="info"
                >Modificar estos datos podría eliminar eventos existentes.</v-alert>

          <v-card-title>
            Configurar Agenda
            <v-spacer></v-spacer>
            <v-icon @click="hide">close</v-icon>
          </v-card-title>

            <v-card-text>

                <v-tabs
                        v-model="tabs"
                        color="grey lighten-2"
                        slider-color="primary"
                >
                    <v-tab ripple>Agenda</v-tab>
                    <v-tab ripple>Bloqueo automático</v-tab>

                    <v-tab-item>
                        <v-sheet  class="pa-3">
                            <v-switch
                                color="primary"
                                prepend-icon="fa-credit-card"
                                label="Cobro anticipado"
                                v-model="request_online_payment"
                                hide-details
                                class="mb-3"
                            />
                            <schedule-config-form
                                    ref="configForm"
                                    :is-update="true"
                                    :interval-start-value="intervalStartValue"
                                    :interval-end-value="intervalEndValue"
                                    :week-days-value="weekDaysValue"
                                    :interval-minutes-value="intervalMinutesValue"
                                    :name-value="nameValue"
                                    :appointment-anticipation-hours-value="appointmentAnticipationHoursValue"
                                    :appointment-limit-days-value="appointmentLimitDaysValue"
                                    :lock="lock"
                            />
                          <v-divider class="my-2"></v-divider>
                          <div class="text-xs-right">
                            <v-btn outline round color="primary" :loading="loading" @click="save">
                              Guardar
                              <v-icon right>save</v-icon>
                            </v-btn>
                          </div>
                        </v-sheet>
                    </v-tab-item>

                    <v-tab-item>
                        <v-sheet class="pa-3">
                            <auto-schedule-form
                                ref="autoScheduleForm"
                                :calendar-start="calendarStart"
                                :calendar-end="calendarEnd"
                                :autoSchedule="autoSchedule"
                                @request-current-events="onRequestCurrentEvents"
                            />
                          <v-divider class="my-2"></v-divider>
                          <div class="text-xs-right">
                              <v-btn outline round color="primary" :loading="loadingAutoSchedule" @click="saveAutoSchedule">
                                Guardar
                                <v-icon right>save</v-icon>
                              </v-btn>
                            </div>
                        </v-sheet>
                    </v-tab-item>

                </v-tabs>

            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    import ScheduleConfigForm from './ScheduleConfigForm'
    import AutoScheduleForm from './AutoScheduleForm'

    import {mapMutations} from 'vuex'
    import {ApiUtils} from '@/utils/ApiUtils'

    export default{
        props: [
            'calendarStart',
            'calendarEnd',
            'intervalStartValue',
            'intervalEndValue',
            'intervalMinutesValue',
            'weekDaysValue',
            'nameValue',
            'lock',
            'scheduleId',
            'autoSchedule',
            'newAutoScheduleEvents',
            'appointmentAnticipationHoursValue',
            'appointmentLimitDaysValue',
            'requestOnlinePaymentValue'
        ],
        components: {
            ScheduleConfigForm,
            AutoScheduleForm
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            onRequestCurrentEvents(){
                this.$emit('request-current-events')
            },
            show(){
                this.dialog = true
            },
            hide(){
                this.dialog = false
            },
            async save() {

                var vm = this
                if(vm.loading) return
                var config = vm.$refs.configForm.getScheduleConfig()

                if(!vm.$refs.configForm.isValid){
                    vm.tabs = 0
                    vm.showSnackBar('Debes completar los datos obligatorios')
                    return
                }

                if(!vm.$refs.autoScheduleForm.isValid()){
                    vm.tabs = 1
                    vm.showSnackBar('Debes completar los datos obligatorios')
                    return
                }

                vm.loading = true
                const response = await ApiUtils.makePatch(`schedules/${vm.scheduleId}`, null, {
                    ...config,
                    request_online_payment: vm.request_online_payment ? 1 : 0,
                })
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando guardar los cambios')
                    return
                }

                const json = await response.json()
                vm.$emit('success', json.result.schedule)
                vm.toast('Cambios guardados correctamente')
                vm.hide()

            },
            async saveAutoSchedule(silent = false){
              const vm = this
              vm.loadingAutoSchedule = true
              const autoScheduleConfig = vm.$refs.autoScheduleForm.config
              const response = await ApiUtils.makePatch(`schedule/${vm.scheduleId}/auto`, null, autoScheduleConfig)
              vm.loadingAutoSchedule = false

              if(!response.ok){
                vm.loading = false
                const autoConfigJson = await response.json()
                if(silent !== true) vm.showSnackBar(autoConfigJson.message || 'Ha ocurrido un error intentando guardar los cambios')
                return
              }

              if(silent !== true) vm.toast('Bloqueo automático establecido correctamente')
              vm.hide()

            },
        },
        data(){
            return {
                tabs: 0,
                alert: false,
                dialog: false,
                loading: false,
                loadingAutoSchedule: false,
                request_online_payment: false,
            }
        },
        watch:{
            newAutoScheduleEvents(evts){
                this.$refs.autoScheduleForm.loadNewEvents(evts)
            },
            requestOnlinePaymentValue(val) {
                this.request_online_payment = val
            }
        }
    }
</script>